import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

type ApiResponse = {
  success: boolean;
  token: string;
};

export function useIntegrationToken() {
  const { orgId } = useAuth();

  return useQuery({
    queryKey: [Query.AppKeys['integration-token'], { orgId }],
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: !!orgId,
    retry: false,
    queryFn: async () => {
      // Place where we decide if we are fetching the org token or the user token
      const isOrgToken = true;
      const endpoint = isOrgToken ? '/crm/org' : '/crm/user';

      const resp = await axios.get<ApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}${endpoint}`);
      return resp.data.token;
    },
  });
}
